import React from "react";
import BigLogo from "../../Assets/Images/logo.png";
import { Animated } from "react-animated-css";

const SplashScreen = () => {
  return (
    <div className="group-image" id="splashscreen">
      <div className="background-image"></div>
      <Animated
        className="big-logo"
        animationIn="slideInDown"
        animationInDuration={2000}
      >
        <img src={BigLogo} />
      </Animated>
    </div>
  );
};

export default SplashScreen;
